<template>
  <article class="faq-item" role="listitem">
    <button
      type="button"
      class="faq-button"
      :aria-expanded="isOpen"
      :aria-controls="`faq-content-${index}`"
      @click="$emit('toggle', index)"
      @keydown="handleKeyDown"
    >
      <h2 class="faq-question" :id="`faq-heading-${index}`">
        {{ faq.question }}
      </h2>
      <span
        class="toggle-icon"
        :style="{
          transform: isOpen ? 'rotate(45deg)' : 'none',
        }"
      >
        +
      </span>
    </button>
    <div
      role="region"
      class="faq-content"
      :id="`faq-content-${index}`"
      :aria-labelledby="`faq-heading-${index}`"
      :style="{
        padding: isOpen ? '0 20px 20px' : '0 20px',
        height: isOpen ? 'auto' : '0',
        opacity: isOpen ? 1 : 0,
        visibility: isOpen ? 'visible' : 'hidden',
      }"
    >
      <div class="faq-answer" v-html="faq.answer"></div>
    </div>
  </article>
</template>

<script setup>
const props = defineProps({
  faq: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle'])

const handleKeyDown = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    emit('toggle', props.index)
  }
}
</script>

<style scoped>
.faq-item {
  border-radius: 10px;
  border: 1px solid #e6e6e9;
  overflow: hidden;
  background-color: #fff;
  transition: all 0.3s ease;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.faq-item:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.faq-button {
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  outline: unset !important;
}

.faq-question {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  line-height: 32.4px;
}

.toggle-icon {
  font-size: 20px;
  color: #000;
  transition: transform 0.3s ease;
}

.faq-content {
  transition: all 0.3s ease;
  overflow: hidden;
}

.faq-answer {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #54595f;
  white-space: pre-wrap;
}
</style>
